import React from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button } from "@aidkitorg/component-library";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useSummaryTableFormState } from "../hooks/useSummaryTableFormState";
import { SummaryTableFormFields } from "./SummaryTableFormFields";
import { useLocalizedStrings } from "../../../Localization";

export const SummaryTableComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const L = useLocalizedStrings()

  const {
    title, setTitle,
    description, setDescription,
    groupByConfig, onGroupByChange,
    buildSummaryTableObject,
    isFormStateValid
  } = useSummaryTableFormState()

  const {
    setStagedComponents,
    getDashboardComponentTranslation
  } = useDashboards()

  const saveSummaryTableComponent = async () => {
    const newSummaryTable = buildSummaryTableObject()

    // Now that backend supports SummaryTable, use proper translation
    const translations = await getDashboardComponentTranslation(newSummaryTable)
    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newSummaryTable, translations.data)
      setStagedComponents((prev) => ([...prev, stagedComponent]))
      setDisplayMode('create')
    } else {
      console.error('Failed to translate summary table component:', newSummaryTable)
      // Fallback: create without translation for now
      const stagedComponent = createStagedComponent(newSummaryTable)
      setStagedComponents((prev) => ([...prev, stagedComponent]))
      setDisplayMode('create')
    }
  }

  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-xl font-bold text-gray-900">
        {L.admin_panel.dashboards.add_summary_table}
      </div>

      <SummaryTableFormFields 
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        groupByConfig={groupByConfig}
        onGroupByChange={onGroupByChange}
      />
  
      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">{L.admin_panel.dashboards.cancel}</Button>
        <Button isDisabled={!isFormStateValid} onClick={saveSummaryTableComponent} className="!w-1/2">{L.admin_panel.dashboards.save}</Button>
      </div>
    </div>
  )
}